import { Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';

declare var MyPhotoLibrary: any;

/*
  Generated class for the HttpReserveProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class PhotoLibrary {

  constructor(
    private pl: Platform
  ) {}

  async requestAuthorization(): Promise<void> {

    if (!this.pl.is('cordova')) return Promise.resolve();

    return new Promise((resolve, reject) => {
      MyPhotoLibrary.requestAuthorization('', () => {
        return resolve();
      }, (error) => {
        console.log('ERROR: MyPhotoLibrary.requestAuthorization catch', error);
        return reject();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/my-photo-library.ts